export const DEFAULT_RISK_DESCRIPTIONS = [
  {
    key: 'description',
    displayValue: 'Description',
  },
  {
    key: 'code',
    displayValue: 'Code',
  },
  {
    key: 'from',
    displayValue: 'From',
  },
  {
    key: 'to',
    displayValue: 'To',
  },
];
